import React, { createContext, useContext, useReducer } from "react";
import { transactionReducer, TRANSACTION_STATES } from "@/app/components/payment/reducers";
import { ACTIONS } from "@/app/components/payment/actions";
import { OrderDetails } from "@/app/interface/digio";
export interface PaymentModes {
    neft: boolean;
    upi: boolean;
    netbanking: boolean;
}

export interface NEFTAccount {
    id: string;
    entity: string;
    ifsc: string;
    bankName: string | null;
    name: string;
    notes: string[];
    accountNumber: string;
    branchName: string;
}

type TransactionState = {
    currentState: keyof typeof TRANSACTION_STATES;
    productCode: string | null;
    isin: string | null;
    orderId: string | null;
    paymentType: string | null;
    error: string | null;
    postDigioTxnData: OrderDetails | null;
    allowedTxnType: PaymentModes;
    NeftDetails: NEFTAccount | null;
};

// Action types based on action names (for typing actions in the reducer)
type ActionType = {
    type: keyof typeof ACTIONS;
    payload?: Partial<TransactionState>;
};

// Initial state
const initialState: TransactionState = {
    currentState: TRANSACTION_STATES.DIGIO_FLOW,
    productCode: null,
    isin: null,
    paymentType: null,
    orderId: null,
    error: null,
    postDigioTxnData: null,
    NeftDetails: null,
    allowedTxnType: {
        neft: true,
        upi: true,
        netbanking: true,
    },
};

type TransactionContextType = {
    state: TransactionState;
    dispatch: React.Dispatch<ActionType>;
    TRANSACTION_STATES: typeof TRANSACTION_STATES;
    ACTIONS: typeof ACTIONS;
};

const TransactionFlowContext = createContext<null | TransactionContextType>(null);

export const TransactionFlowProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [state, dispatch] = useReducer(transactionReducer, initialState);

    return (
        <TransactionFlowContext.Provider value={{ state, dispatch, TRANSACTION_STATES, ACTIONS }}>
            {children}
        </TransactionFlowContext.Provider>
    );
};

export const useTransactionFlow = () => {
    const context = useContext(TransactionFlowContext);
    if (!context) {
        throw new Error("useTransactionFlow must be used within a TransactionFlowProvider");
    }
    return context;
};
